import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { NameSection } from "@/components/site/NameSection";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Pricing } from "@/components/site/Pricing";
import { Reviews } from "@/components/site/Reviews";
import { Estimate } from "@/components/site/Estimate";
import { Bento } from "@/components/site/Bento";
import { Process } from "@/components/site/Process";
import { FinalCta, Footer } from "@/components/site/FinalCta";
import { useSmoothScroll } from "@/components/site/SmoothScroll";

export default function Home() {
  useSmoothScroll();
  return (
    <main className="bg-[#090A0C] text-zinc-100" data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <NameSection />
      <Manifesto />
      <Services />
      <Pricing />
      <Reviews />
      <Estimate />
      <Bento />
      <Process />
      <FinalCta />
      <Footer />
    </main>
  );
}
